import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const ReverseJadeLizardSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02063 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H32.9406" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.29279 15.2414H10.4609L13.6794 13.2104H20.1487L23.9507 18.0615" stroke="#089981" strokeWidth="2"/>
        <path d="M33 29.6566L23.9505 18.0612" stroke="#A40C0C" strokeWidth="2"/>
    </svg>
)
const ReverseJadeLizard: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {ReverseJadeLizardSvg(props)}
    </SvgIcon>
));
export default ReverseJadeLizard